import { Flex } from "@mantine/core";
import { useMemo } from "react";

import ActionIcon from "../../../components/ActionIcon/ActionIcon.tsx";
import { DatabaseMetadataPopover } from "../../../components/DatabaseMetadataPopover/DatabaseMetadataPopover.tsx";
import SvgDelete from "../../../components/Icons/Delete.tsx";
import SvgEdit from "../../../components/Icons/Edit.tsx";
import Spoiler from "../../../components/Spoiler/Spoiler.tsx";
import { TableData } from "../../../components/Table/types.ts";
import { LimitRequestPaymaster } from "../../../types/limitRequest/paymaster.ts";
import { toHumanReadable } from "../../../utils/string.ts";

interface Props {
  data: LimitRequestPaymaster[] | undefined;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

export const useLimitRequestPaymastersTableData = ({
  data,
  onEdit,
  onDelete,
}: Props): TableData => {
  const columns = [
    {
      accessor: "id",
      hidden: true,
    },
    {
      accessor: "name",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "Paymaster",
            fieldName: "name",
          }}
        >
          Paymaster Name
        </DatabaseMetadataPopover>
      ),
    },
    {
      accessor: "status",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "LimitRequestPaymaster",
            fieldName: "status",
          }}
        >
          Approval Status
        </DatabaseMetadataPopover>
      ),
    },
    {
      accessor: "notes",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "LimitRequestPaymaster",
            fieldName: "notes",
          }}
        >
          Notes
        </DatabaseMetadataPopover>
      ),
    },
    { accessor: "actions", title: " " },
  ];

  const rows = useMemo(() => {
    return data?.map((item) => ({
      id: item.id,
      name: item.paymaster.name,
      status: item.status && toHumanReadable(item.status),
      notes: item.notes && <Spoiler maxStringLength={300} text={item.notes} />,
      actions: (
        <Flex gap={12}>
          <ActionIcon onClick={() => onEdit(item.id)}>
            <SvgEdit />
          </ActionIcon>
          <ActionIcon variant="error" onClick={() => onDelete(item.id)}>
            <SvgDelete />
          </ActionIcon>
        </Flex>
      ),
    }));
  }, [data, onDelete, onEdit]);

  return [columns, rows];
};
